import { defineComponent as v, ref as C, computed as I, createBlock as s, openBlock as a, unref as r, withModifiers as x, withCtx as c, renderSlot as m, createTextVNode as y, toDisplayString as w, createElementVNode as k, normalizeClass as g, createCommentVNode as h } from "vue";
import { componentHasFocus as B } from "../InputSelect.helpers.js";
import { RevListItemInteractive as N } from "@ds/components/ListItemInteractive";
import { usePropsValidation as V } from "../../../composables/usePropsValidation.js";
import $ from "../../../icons/generated/IconCheckLarge.vue2.js";
import { tw as i } from "../../../utils/tailwind.js";
const F = /* @__PURE__ */ v({
  name: "RevInputSelectItem",
  __name: "InputSelectItem",
  props: {
    option: {},
    label: {},
    isSelected: { type: Boolean },
    id: { default: "" },
    itemsCenter: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(e, { expose: d, emit: f }) {
    const o = e, u = f;
    V({
      "The id prop is required if options are of type `OptionItem`": () => !o.option.id && !o.id
    });
    const n = C(null);
    function p(t) {
      u("select", t);
    }
    function b() {
      const t = n.value;
      t && B(t) && t.focus();
    }
    d({ focus: b });
    const S = I(() => [
      i`rounded-sm pointer-events-none mt-2 flex size-20 items-center justify-center ease-in motion-safe:transition-colors motion-safe:duration-[50ms]`,
      !o.isSelected && i`bg-action-default-low border-static-default-hi border`,
      o.isSelected && i`bg-action-default-low-pressed text-onaction-default-low-pressed`
    ]);
    return (t, l) => (a(), s(r(N), {
      id: e.option.id || e.id,
      ref_key: "listItem",
      ref: n,
      "aria-label": e.label,
      "aria-selected": e.isSelected,
      class: "group",
      "items-center": e.itemsCenter,
      role: "option",
      onClick: l[0] || (l[0] = x((z) => p(e.option), ["prevent"]))
    }, {
      prefix: c(() => [
        m(t.$slots, "prefix", {}, () => [
          k("div", {
            class: g(S.value)
          }, [
            e.isSelected ? (a(), s(r($), {
              key: 0,
              size: "16"
            })) : h("", !0)
          ], 2)
        ])
      ]),
      label: c(() => [
        m(t.$slots, "label", {}, () => [
          y(w(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "aria-label", "aria-selected", "items-center"]));
  }
});
export {
  F as default
};
